import { AdaAction } from '../actions'

export async function handleLoadAutoDesignResult(action: AdaAction) {
  window.AutoDesignHelper.loadAutoDesignResult(action.args.project_id, action.args.identifier)
}
